import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";

const EditOccupation = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const occupationData = useSelector((state) => state.Modal.val);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("occupation_id", occupationData.occupation_id);
    formData.append("occupation_name", data.occupation_name);
    formData.append(
      "active_flag",
      data.active_flag || occupationData?.active_flag
    );

    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateOccupation`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          dispatch(handleEditClose());
        } else if (data.duplicate === true) {
          toast.error("Occupation is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box mb="20px">
          <TextField
            defaultValue={occupationData?.occupation_name}
            size="small"
            fullWidth
            label="User level Name*"
            variant="outlined"
            {...register("occupation_name", { required: true })}
          />
          {errors?.occupation_name?.type === "required" && (
            <ErrorMessage>User level Name is required*</ErrorMessage>
          )}
        </Box>

        <Box>
          <TextField
            select
            defaultValue={occupationData?.active_flag}
            size="small"
            fullWidth
            label="Active Status*"
            variant="outlined"
            {...register("active_flag", { required: true })}
          >
            <MenuItem value="Y">Active</MenuItem>
            <MenuItem value="N">Inactive</MenuItem>
          </TextField>
          {errors?.active_flag?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
        {/* )} */}
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Update Occupation
          </ThemButton>
        )}
      </Box>
      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
    </form>
  );
};

export default EditOccupation;
